import type { SpaceGroup } from "@circle-react/types/SpaceGroup";
import {
  Select,
  type SearchableSelectProps,
} from "@circleco/compass/components/Select";

import { t } from "@/i18n-js/instance";

import { useSpaceGroupSelectOptions } from "./useSpaceGroupSelectOptions";

const I18N_ROOT = "space_group_select_compass";

export interface SpaceGroupSelectCompassComponentProps extends Omit<
  SearchableSelectProps<number>,
  "options" | "value" | "onValueChange" | "i18n" | "defaultValue" | "searchable"
> {
  "data-testid"?: string;
  onChange?: (id: number | null) => void;
  spaceGroups?: SpaceGroup[];
  value?: number | null;
}

export const SpaceGroupSelectCompassComponent = ({
  "data-testid": dataTestId = "space-group-selector",
  onChange,
  spaceGroups = [],
  value,
  ...selectProps
}: SpaceGroupSelectCompassComponentProps) => {
  const { options, selectedOption } = useSpaceGroupSelectOptions({
    spaceGroups,
    value,
  });

  return (
    <Select
      options={options}
      value={selectedOption}
      data-testid={dataTestId}
      {...selectProps}
      searchable
      onValueChange={opt => {
        onChange?.(opt?.value ?? null);
      }}
      placeholder={t([I18N_ROOT, "placeholder"])}
      emptyMessage={t([I18N_ROOT, "empty_message"])}
      i18n={{
        searchPlaceholder: t([I18N_ROOT, "search_placeholder"]),
      }}
    />
  );
};

SpaceGroupSelectCompassComponent.displayName =
  "SpaceGroupSelectCompassComponent";
